import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from '../../common/formComponents/Input';
import ResinPicker from '../../common/formComponents/ResinPicker';
import CorePicker from '../../common/formComponents/CorePicker';
import { ALLOW_EDIT_MATERIAL_NAME } from '../../../constants/features';
import Core from '../../../models/Core';
import { materialPropType } from '../../../lib/shapes';

export function EditCoreFields(props) {
  const {
    layer,
    manufacturerOptions,
    resinOptions,
    materialOptions,
    selectedResinId,
    selectedMaterial,
    lengthUnit
  } = props;
  const placeholder =`${layer.displayName}`;

  return (
    <div>
      {ALLOW_EDIT_MATERIAL_NAME ? ( 
        <Field
          id="name"
          name="name"
          label={placeholder}
          fullWidth
          component={Input}
        />
      ) : null}
      <Field
        id="resin"
        name="resin"
        component={ResinPicker}
        required
        manufacturerOptions={manufacturerOptions}
        resinOptions={resinOptions}
      />
      <Field
        id="material"
        name="material"
        resinId={selectedResinId}
        component={CorePicker}
        required
        options={materialOptions}
        target={layer}
        selected={selectedMaterial}
        lengthUnit={lengthUnit}
      />
    </div>
  );
}

EditCoreFields.propTypes = {
  layer: PropTypes.instanceOf(Core).isRequired,
  manufacturerOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })).isRequired,
  resinOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  materialOptions: PropTypes.arrayOf(PropTypes.shape(materialPropType)).isRequired,
  selectedResinId: PropTypes.string,
  selectedMaterial: PropTypes.shape(materialPropType),
  lengthUnit:       PropTypes.string.isRequired,
};

EditCoreFields.defaultProps = {
  selectedMaterial: null,
  selectedResinId: null,
}

export default EditCoreFields;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditCoreFields.js